
import { defineComponent, onMounted, PropType, ref, watch } from 'vue';
import { CouponsWithImageUrl } from '@/lib/api/coupons.api';
import { useCouponImageStore } from '@/store/useCouponImage';
import Cropper from 'cropperjs';

export default defineComponent({
  name: 'coupon-cropper',
  props: {
    item: {
      required: true,
      type: Object as PropType<CouponsWithImageUrl>,
    },
  },
  setup(props, context) {
    const couponImage = useCouponImageStore();

    const canvas = ref(null);
    const cropper = ref<Cropper | null>(null);
    const preciseRotation = ref(0);

    const rotation = ref(0);

    onMounted(() => {
      if (canvas.value != undefined) {
        const context = canvas.value.getContext('2d');
        const imageElement = new Image();
        imageElement.crossOrigin = 'Anonymous';
        imageElement.onload = () => {
          if (rotation.value % 180) {
            canvas.value.width = imageElement.height;
            canvas.value.height = imageElement.width;
          } else {
            canvas.value.width = imageElement.width;
            canvas.value.height = imageElement.height;
          }
          context.rotate((rotation.value * Math.PI) / 180);
          if (rotation.value === 90) {
            context.translate(0, -canvas.value.width);
          } else if (rotation.value === 180) {
            context.translate(-canvas.value.width, -canvas.value.height);
          } else if (rotation.value === 270) {
            context.translate(-canvas.value.height, 0);
          }
          context.drawImage(imageElement, 0, 0);
          cropper.value = new Cropper(canvas.value, {
            autoCrop : true,
            background: true,
            autoCropArea: 1,
          });
        };
        imageElement.src = props.item.imageUrl;
      }
    });

    watch([preciseRotation], ([value]) => {
      if(value) {
        cropper.value.rotateTo(value);
      }
    });

    const rotate = (deg: number) => {
      rotation.value = (rotation.value + deg) % 360;
      preciseRotation.value = rotation.value;
      const containerData = cropper.value.getContainerData();
      const newData = {
        height: 2,
        width: 2,
        top: 0,
        left: (containerData.width / 2) - 1,
      }

      cropper.value.setCropBoxData(newData);
      cropper.value.rotate(deg);

      const canvasData = cropper.value.getCanvasData();
      const newWidth = canvasData.width * (containerData.height / canvasData.height);
      let newCanvasData = {
        height: containerData.height,
        width: newWidth,
        top: 0,
        left: (containerData.width - newWidth) / 2,
      };

      if (newWidth >= containerData.width) {
        const newHeight = canvasData.height * (containerData.width / canvasData.width);
        newCanvasData = {
          height: newHeight,
          width: containerData.width,
          top: (containerData.height - newHeight) / 2,
          left: 0,
        }
      }

      cropper.value.setCanvasData(newCanvasData);
      cropper.value.setCropBoxData(newCanvasData);
    };

    const close = (reload: boolean) => {
      context.emit('close', reload);
    };
    const upload = () => {
      let cvn = cropper.value.getCroppedCanvas({
        maxWidth: 1000,
        maxHeight: 1000,
      });

      cvn.toBlob(async (blob) => {
        try {
          await couponImage.uploadImage(blob, props.item);
          close(true);
        } catch (error) {
          console.log(error);
        }
      });
    };

    return {
      close,
      upload,
      rotate,
      canvas,
      cropper,
      preciseRotation,
    };
  },
});
